import api from './api'; // Import Axios instance

// Login function
export const login = async (email, password, rememberMe) => {
    try {
        const response = await api.post('/user/login', { email, password, rememberMe });

        // Assuming API returns { accessToken, refreshToken }
        const { signInResult, tokens, user, totpUrl } = response.data.payload;

        const loginTimestamp = new Date().toISOString();

        // Store tokens in localStorage or sessionStorage
        if (rememberMe) {
            localStorage.setItem('accessToken', tokens.accessToken);
            localStorage.setItem('refreshToken', tokens.refreshToken);
            localStorage.setItem('lastLogin', loginTimestamp);
        } else {
            sessionStorage.setItem('accessToken', tokens.accessToken);
            sessionStorage.setItem('refreshToken', tokens.refreshToken);
            sessionStorage.setItem('lastLogin', loginTimestamp);
        }

        return response.data.payload;
    } catch (error) {
        if (error.response) {

            const { signInResult, tokens, user, totpUrl } = error.response.data.payload;

            if (error.status == 401 && signInResult == 2) {
                //2FA

                if (totpUrl) {
                    //First time setup of 2FA needed
                    var err = new Error("2FA_SETUP")
                    err.totpUrl = totpUrl
                    throw err
                } else {
                    throw new Error("2FA")
                }
            }
            else if (error.status == 401 && signInResult == 4) {
                throw new Error("LOCKED_OUT")
            }
            else
            {
                throw new Error("LOGIN_FAIL")
            }


        } else {
            throw new Error("LOGIN_FAIL")
        }
    }
};

export const validateTotp = async (code, email) => {
    try {

        const response = await api.post('/user/totp', { code, email });

        const { signInResult, tokens, user, totpUrl } = response.data.payload;
        const loginTimestamp = new Date().toISOString();

        sessionStorage.setItem('accessToken', tokens.accessToken);
        sessionStorage.setItem('refreshToken', tokens.refreshToken);
        sessionStorage.setItem('lastLogin', loginTimestamp);

        return response.data.payload;

    } catch (err) {
        if (err.response) {

            const { signInResult, tokens, user, totpUrl } = err.response.data.payload;

            if (err.status == 401 && signInResult == 4) {
                throw new Error("LOCKED_OUT")
            } else {
                throw new Error("FAILED_TOTP")
            }

        } else {
            throw new Error("FAILED_TOTP")
        }


    }
}

// Logout function
export const logout = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('lastLogin');
    sessionStorage.removeItem('accessToken');
    sessionStorage.removeItem('refreshToken');
    sessionStorage.removeItem('lastLogin');
};

// Get the auth token from either storage system
export const getAccessToken = () => {
    return localStorage.getItem('accessToken') || sessionStorage.getItem('accessToken');
};

export const refreshAccessToken = async () => {
    console.log("refresh token");
    try {
        const tokenToBeRefreshed =
            localStorage.getItem('refreshToken') || sessionStorage.getItem('refreshToken');


        if (!tokenToBeRefreshed) throw new Error('No refresh token available');
        const response = await api.post(`/user/refreshToken/${tokenToBeRefreshed}`);
        const { accessToken, refreshToken } = response.data.payload;

        if (localStorage.getItem('refreshToken')) {
            localStorage.setItem('accessToken', accessToken);
            localStorage.setItem('refreshToken', refreshToken);
        } else {
            sessionStorage.setItem('accessToken', accessToken);
            sessionStorage.setItem('refreshToken', refreshToken);
        }

        return response.data; // Returns `{ payload: { accessToken, refreshToken }, ... }`
    } catch (error) {
        console.error('Token refresh failed', error);

        if (error.response && (error.response.status === 401 || error.response.status === 400)) {
            logout();
            window.location.href = '/';
        }

        throw error;
    }
};

